import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'vault-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PageHeaderComponent {}
